import React from 'react';
import { getIdentityUrl, getWACUrl } from '@css-xp/ppc-utils';
import Button from '@atlaskit/button';
import { AtlassianLogo } from '@atlaskit/logo-latest';
import { B200, B400 } from '@atlaskit/theme/colors';
import { useApplicationContext } from '@css-xp/base';
// @ts-ignore
import OrderConfirmation from './assets/order-confirmation.svg';
import './order-confirmation.scss';

type ConditionalGetStartedProps =
  | {
      showGetStartedAction?: false;
      onGetStarted?: never;
    }
  | {
      showGetStartedAction: true;
      onGetStarted: (link: string) => void;
    };

export type OrderConfirmationProps = ConditionalGetStartedProps & {
  orderSlug: string;
  orderId: string;
  transactionAccountId: string;
};

const getAtlassianLogo = (size: 'small' | 'medium' | 'large') => {
  return (
    <AtlassianLogo iconColor={B200} iconGradientStart={B400} iconGradientStop={B200} textColor={B400} size={size} />
  );
};

export const getProvisioningUrl = (orderId: string, transactionAccountId: string, email: string): string => {
  const queryParams = [
    `login_hint=${encodeURIComponent(email)}`,
    `prompt=none`,
    `continue=${encodeURIComponent(
      `${getWACUrl()}/buy/cloud/site-setup?orderId=${orderId}&transactionAccount=${transactionAccountId}`
    )}`,
  ];
  return `${getIdentityUrl()}/login?${queryParams.join('&')}`;
};

export const OrderConfirmationStep = ({
  orderSlug,
  orderId,
  transactionAccountId,
  showGetStartedAction,
  onGetStarted,
}: OrderConfirmationProps) => {
  const { email } = useApplicationContext();
  return (
    <>
      <div className="order-confirmation-container" data-testid="ppc-order-confirmation">
        <div className="atlassian-logo">{getAtlassianLogo('medium')}</div>
        <p className="order-confirmation-header">You have your order</p>
        {/*// @ts-ignore */}
        {<img src={OrderConfirmation} className="order-confirmation-image" />}
        <div className="description">
          <h5>The order number is {orderSlug}</h5>
          <p>
            {showGetStartedAction
              ? `Get started by setting up a cloud site.`
              : `The products will be added to the site shortly.`}
          </p>
          {showGetStartedAction && (
            <Button
              className="get-started-button"
              appearance="primary"
              onClick={() => {
                onGetStarted && onGetStarted(getProvisioningUrl(orderId, transactionAccountId, email));
              }}
            >
              Get started
            </Button>
          )}
          <hr className="border" />
        </div>
      </div>
    </>
  );
};
